
import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface AccordionTriggerProps {
  children: React.ReactNode;
  onClick: () => void;
  isOpen: boolean;
}

export const AccordionTrigger: React.FC<AccordionTriggerProps> = ({ children, onClick, isOpen }) => (
  <div 
    className="flex justify-between items-center py-1 cursor-pointer hover:bg-gray-100 rounded px-2" 
    onClick={onClick}
  >
    {children}
    {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
  </div>
);

interface AccordionContentProps {
  children: React.ReactNode;
  isOpen: boolean;
}

export const AccordionContent: React.FC<AccordionContentProps> = ({ children, isOpen }) => (
  <div className={`AccordionContent pt-1 pb-1 px-1 ${isOpen ? 'block' : 'hidden'}`}>
    {children}
  </div>
);

